import Phaser from "phaser";
import { GAME_HEIGHT, GAME_WIDTH } from "@/game/data/constants";

export function createHomeGameConfig(
  parent: HTMLElement,
  scene: Phaser.Types.Scenes.SceneType[],
  extra?: Partial<Phaser.Types.Core.GameConfig>,
): Phaser.Types.Core.GameConfig {
  return createGameConfig(parent, scene, {
    ...extra,
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.NO_CENTER,
    },
  });
}

export function createGameConfig(
  parent: HTMLElement,
  scene: Phaser.Types.Scenes.SceneType[],
  extra?: Partial<Phaser.Types.Core.GameConfig>,
): Phaser.Types.Core.GameConfig {
  const { scale: extraScale, ...restExtra } = extra ?? {};
  return {
    ...restExtra,
    type: Phaser.AUTO,
    parent,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: "#0f1419",
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      ...extraScale,
    },
    scene,
    fps: {
      target: 60,
      forceSetTimeOut: false,
    },
    physics: {
      default: "arcade",
      arcade: {
        gravity: { x: 0, y: 0 },
        debug: false,
      },
    },
    title: "Mind Survival",
  };
}
